export default __webpack_public_path__ + "static/media/purple-vertical-bars.59e86c56.svg";